import React, { createContext, useContext, useState, useEffect } from "react"

const OPENCAGE_DATE_API_KEY = "8eaa0f3dfd984dd7a9128998b7ede595"

export interface CurrencyExchangeContextProps {
  userCountry: any
  getCountryCode: () => string
}

const CurrencyExchangeContext = createContext<CurrencyExchangeContextProps>({
  userCountry: {},
  getCountryCode: () => "",
})

export const useCurrencyExchange = () => {
  return useContext(CurrencyExchangeContext)
}

export const CurrencyExchange = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [userCountry, setUserCountry] = useState<any>({})

  const getCurrentPosition = async () => {
    // TODO: Add back if needed
    // const getCurrentPosition = () =>
    //   new Promise((resolve, reject) => {
    //     navigator.geolocation.getCurrentPosition(resolve, reject)
    //   }) as Promise<GeolocationPosition>

    // const position = await getCurrentPosition()
    // return position
    return null
  }

  const fetchData = async () => {
    try {
      const position = (await getCurrentPosition()) as any
      if (!position) return
      const { latitude, longitude } = position.coords
      const queryParams = new URLSearchParams({
        key: OPENCAGE_DATE_API_KEY,
        q: `${latitude}+${longitude}`,
        pretty: "1",
      })
      const reverseGeocodingUrl = `https://api.opencagedata.com/geocode/v1/json?${queryParams.toString()}`
      const response = await fetch(reverseGeocodingUrl)
      const data = await response.json()
      if (data.results && data.results.length > 0) {
        const { country } = data.results[0].components
        const restcountriesUrl = `https://restcountries.com/v3.1/name/${country}`
        const countryResponse = await fetch(restcountriesUrl)
        const countryData = await countryResponse.json()
        const currentCountry = countryData?.filter(
          (item: any) =>
            item.cca2 === data.results[0]?.components?.["ISO_3166-1_alpha-2"],
        )?.[0]
        if (currentCountry) {
          setUserCountry(currentCountry)
        } else {
          setUserCountry("")
        }
      } else {
        setUserCountry("")
      }
    } catch (error) {
      setUserCountry("")
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const getCountryCode = () => {
    return userCountry?.cca2 || "US"
  }

  const contextValue = {
    userCountry,
    getCountryCode,
  }

  return (
    <CurrencyExchangeContext.Provider value={contextValue}>
      {children}
    </CurrencyExchangeContext.Provider>
  )
}
